module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("eUI21"))).then(() => parcelRequire('hEqeo'));